export default __webpack_public_path__ + "static/media/Astro_Libra_White.4e17e286.png";